import { effectiveRoles } from "./instanceRoleInheritance";

const MANAGE_ROLES = new Set(["administrator", "super-administrator", "admin", "finance-rep", "finance"]);
const VIEW_ONLY_ROLES = new Set(["client-rep", "order-rep"]);

export const normalizeInvoiceRoles = (authState = {}) => {
  const values = [
    ...(Array.isArray(authState?.roles) ? authState.roles : []),
    ...(authState?.role ? [authState.role] : []),
    ...(Array.isArray(authState?.user?.roles) ? authState.user.roles : []),
    ...(authState?.user?.role ? [authState.user.role] : []),
  ];

  return new Set(
    values.flatMap(effectiveRoles)
  );
};

export const canManageInvoicesForRoles = (roles = new Set()) =>
  [...MANAGE_ROLES].some((role) => roles.has(role));

export const canViewInvoicesForRoles = (roles = new Set()) =>
  canManageInvoicesForRoles(roles) ||
  [...VIEW_ONLY_ROLES].some((role) => roles.has(role));

export const getInvoicePermissionState = (authState = {}) => {
  const roles = normalizeInvoiceRoles(authState);
  const canManageInvoices = canManageInvoicesForRoles(roles);
  const canViewInvoices = canViewInvoicesForRoles(roles);

  return {
    roles,
    canManageInvoices,
    canViewInvoices,
    readOnlyInvoiceAccess: canViewInvoices && !canManageInvoices,
  };
};

export const shouldShowInvoicesTab = ({
  canManageInvoices = false,
  canViewInvoices = false,
  invoiceCount = 0,
} = {}) => canManageInvoices || (canViewInvoices && Number(invoiceCount || 0) > 0);

export const resolveInvoiceRouteAccess = ({
  canManageInvoices = false,
  canViewInvoices = false,
  invoiceCount = 0,
  isInvoiceRoute = false,
  isInvoiceEditRoute = false,
  isInvoiceCreateRoute = false,
} = {}) => {
  if (!isInvoiceRoute) return "allow";

  const canShowList = shouldShowInvoicesTab({ canManageInvoices, canViewInvoices, invoiceCount });
  if (!canShowList) return "overview";
  if ((isInvoiceEditRoute || isInvoiceCreateRoute) && !canManageInvoices) return "list";
  return "allow";
};
